import React from 'react'
import { FlexWrapper } from 'lib/ui/components'
import { ReportData } from 'hooks/reports'
import { PieChart } from '../PieChart'
import { BarChart } from '../BarChart'
import { WordCloud } from '../WordCloud'
import { Recommendations } from '../Recommendations'
import { TableWrapper, ChartWrapper } from './../../styled'

interface Props {
  report: ReportData
  isPDF: boolean
}

export const ReportInfo = ({ report, isPDF }: Props) => {
  const isBarChart = report?.display_type === 'bar_chart'

  return (
    <TableWrapper isPDF={isPDF}>
      <h3>{report.title}</h3>
      <FlexWrapper kind='between' wrap verticalCenter>
        <ChartWrapper isPDF={isPDF}>
          {(() => {
            switch (report.display_type) {
              case 'pie_chart':
                return <PieChart options={report.question_options} totalResponses={report.answered_by} />
              case 'bar_chart':
                return <BarChart options={report.question_options} totalResponses={report.answered_by} />
              case 'wordcloud':
                return <WordCloud options={report.question_options} totalResponses={report.answered_by} />
              default:
                return <PieChart options={report.question_options} totalResponses={report.answered_by} />
            }
          })()}
        </ChartWrapper>
        <Recommendations options={report.question_options} showNumbers={!!isBarChart} isPDF={isPDF} />
      </FlexWrapper>
    </TableWrapper>
  )
}
